import { ButtonType, ButtonWidget } from '@tableau/widgets';
import * as React from 'react';

import { imgPath } from '~src/common/utilities/ImgUrl';

export type EditDomainButtonProps = Readonly<{
    onClick: () => void;
}>;

export function EditDomainButton(props: EditDomainButtonProps) {
    return (
        <ButtonWidget
            testId="edit-domain-button"
            buttonType={ButtonType.Icon}
            onClick={props.onClick}
        >
            <img src={imgPath('pencil_14px_small.svg')} alt={''} />
        </ButtonWidget>
    );
}
